import { MATERIAL } from './api'
import { METHOD, request } from '@/utils/request'

/**
 * 获取领取材料数据-分页
 * @param {*} params 
 * @returns 
 */
export function findAll(params) {
  return request(
    MATERIAL + '/getMaterialList',
    METHOD.GET,
    params
  )
}

/**
 * getOne
 * @param {*} params 
 * @returns 
 */
export function getOne(params) {
  return request(
    MATERIAL + '/getMaterialById',
    METHOD.GET,
    params
  )
}

/**
 * save
 * @param {*} data 
 * @returns 
 */
export function save(data) {
  return request(
    MATERIAL + '/addMaterial',
    METHOD.POST,
    data
  )
}

/**
 * update
 * @param {*} data 
 * @returns 
 */
export function update(data) {
  return request(
    MATERIAL + '/editMaterial',
    METHOD.POST,
    data
  )
}

/**
 * enable
 * @param {*} params 
 * @returns 
 */
export function enable(params) {
  return request(
    MATERIAL + '/enableMaterial',
    METHOD.POST,
    null,
    { params }
  )
}

/**
 * disable
 * @param {*} params 
 * @returns 
 */
export function disable(params) {
  return request(
    MATERIAL + '/disableMaterial',
    METHOD.POST,
    null,
    { params }
  )
}

/**
 * dels
 * @param {*} params 
 * @returns 
 */
export function dels(params) {
  return request(
    MATERIAL + '/removeMaterialByIds',
    METHOD.DELETE,
    null,
    { params }
  )
}
